export const PAGE_SIZE = 10;
export const buttonClass = "rounded-lg px-4 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50";
export const inputClass = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Converts the API datetime format ("31-Aug-2026, 04:58 PM") or ISO strings to a datetime-local value.
export function toDateTimeInput(value) {
  if (!value) return "";
  const match = /^(\d{2})-([A-Za-z]{3})-(\d{4}), (\d{2}):(\d{2}) (AM|PM)$/.exec(value);
  if (match) {
    const [, day, month, year, hour, minute, period] = match;
    const hours = (Number(hour) % 12) + (period === "PM" ? 12 : 0);
    const monthNumber = String(MONTHS.indexOf(month) + 1).padStart(2, "0");
    return `${year}-${monthNumber}-${day}T${String(hours).padStart(2, "0")}:${minute}`;
  }
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value) ? value.slice(0, 16) : "";
}

export function errorMessage(error) {
  const data = error.response?.data;
  if (typeof data === "string") return "The server could not process this request. Please try again.";
  if (data && typeof data === "object") {
    return Object.entries(data)
      .map(([field, messages]) => `${field === "detail" ? "" : `${field}: `}${Array.isArray(messages) ? messages.join(" ") : messages}`)
      .join(" ");
  }
  return "Could not reach the server. Please try again.";
}
